var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('topbar'), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "header line"
  }, [_c('div', {
    staticClass: "w1200 bc"
  }, [_c('a', {
    staticClass: "logo fl",
    attrs: {
      "href": _vm.indexUrl,
      "title": "云永云商城"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "search"
  }, [_c('span', {
    staticClass: "ico"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sortParam),
      expression: "sortParam"
    }],
    staticClass: "text",
    attrs: {
      "type": "text",
      "placeholder": "请输入关键字"
    },
    domProps: {
      "value": (_vm.sortParam)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sortParam = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.findGoods()
      }
    }
  }, [_vm._v("搜商品")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "margin-left": "3px"
    },
    on: {
      "click": function($event) {
        _vm.findShops()
      }
    }
  }, [_vm._v("搜店铺")])]), _vm._v(" "), _c('div', {
    staticClass: "r-box fr",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "mycart",
    on: {
      "mouseenter": function($event) {
        _vm.shopCarShow()
      },
      "mouseleave": function($event) {
        _vm.shopCarHide()
      }
    }
  }, [_c('i', {
    staticClass: "ico-cart"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("我的购物车")]), _vm._v(" "), _c('span', {
    staticClass: "ico-shopping-amount"
  }, [_vm._v(_vm._s(_vm.shoppingCartNum))]), _vm._v(" "), _c('i', {
    staticClass: "ico-r"
  }), _vm._v(" "), _c('div', {
    staticClass: "goods-list none",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), (_vm.shoppingCartNum == 0) ? _c('div', {
    staticClass: "no-goods"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/images/settleup-nogoods.png"),
      "width": "57",
      "height": "49"
    }
  }), _vm._v("购物车中还没有商品，赶紧选购吧！\n\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.shoppingCartNum > 0) ? _c('div', {
    staticClass: "mylist"
  }, [_c('h4', [_vm._v("最新加入的商品")]), _vm._v(" "), _c('ul', _vm._l((_vm.boList), function(bo) {
    return _c('li', {
      staticClass: "li-2",
      attrs: {
        "id": bo.goodsCode + '_cart_pro'
      }
    }, [_c('a', {
      staticClass: "fl spic",
      attrs: {
        "href": "#"
      }
    }, [_c('img', {
      attrs: {
        "src": bo.imgSmall,
        "width": "50",
        "height": "50"
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "name"
    }, [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(bo.goodsName))]), _vm._v("    "), _c('span', [_vm._v("数量：" + _vm._s(bo.goodsNumber))])]), _vm._v(" "), _c('p', {
      staticClass: "other"
    }, [_c('span', [_vm._v("￥" + _vm._s(bo.goodsPrice))]), _c('br'), _vm._v(" "), _c('a', {
      staticClass: "del",
      on: {
        "click": function($event) {
          _vm.deleteGoods(bo.goodsCode)
        }
      }
    }, [_vm._v("删除")])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "fbar"
  }, [_c('span', {
    staticClass: "fl ml10"
  }, [_vm._v("共" + _vm._s(_vm.count) + "件商品　共计"), _c('b', [_vm._v("￥ " + _vm._s(_vm.sumMoney))])]), _vm._v(" "), _c('a', {
    staticClass: "fr gobuy",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("去购物车")])])]) : _vm._e()])]), _vm._v(" "), (_vm.isLogin == true) ? _c('div', {
    staticClass: "myorder ml25",
    on: {
      "mouseenter": function($event) {
        _vm.orderShow()
      },
      "mouseleave": function($event) {
        _vm.orderHide()
      }
    }
  }, [_c('i', {
    staticClass: "ico-orders"
  }), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.goOrder('')
      }
    }
  }, [_vm._v("我的订单 "), _c('span', {
    staticClass: "ico-shopping-amount"
  }, [_vm._v(_vm._s(_vm.allCount))])]), _vm._v(" "), _c('i', {
    staticClass: "ico-r"
  }), _vm._v(" "), _c('div', {
    staticClass: "orders-list orders"
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.goOrder('wait_buyer_pay')
      }
    }
  }, [_vm._v("等待买家付款 "), _c('span', {
    staticClass: "ico-shopping-amount",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.payCount))])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.goOrder('wait_send_goods')
      }
    }
  }, [_vm._v("等待卖家发货 "), _c('span', {
    staticClass: "ico-shopping-amount",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.sendCount))])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.goOrder('wait_buyer_confirm_goods')
      }
    }
  }, [_vm._v("等待确认收货 "), _c('span', {
    staticClass: "ico-shopping-amount",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.putCount))])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.goOrder('trade_finish')
      }
    }
  }, [_vm._v("订单完成 "), _c('span', {
    staticClass: "ico-shopping-amount",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.receiveCount))])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.goOrder('trade_close')
      }
    }
  }, [_vm._v("订单关闭 "), _c('span', {
    staticClass: "ico-shopping-amount",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.closeCount))])])])])])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "head-nav clear-l"
  }, [_c('div', {
    staticClass: "w1200 bc"
  }, [_c('div', {
    staticClass: "mall-categorys fl"
  }, [_c('div', {
    staticClass: "hd",
    on: {
      "mouseenter": function($event) {
        _vm.goodsCateShow()
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("全部分类")])]), _vm._v(" "), _c('div', {
    staticClass: "sc-submenu none",
    staticStyle: {
      "opacity": "0.85",
      "background": "rgb(130, 122, 123)"
    },
    on: {
      "mouseleave": function($event) {
        _vm.goodsCateHidden()
      }
    }
  }, [_c('ul', _vm._l((_vm.catList), function(cat) {
    return _c('li', {
      staticClass: "li-1",
      on: {
        "mouseleave": function($event) {
          _vm.childCateHide(cat.catCode)
        }
      }
    }, [_c('div', {
      staticClass: "yj",
      staticStyle: {
        "background": "rgb(130, 122, 123)"
      },
      on: {
        "mouseenter": function($event) {
          _vm.childCateShow(cat.catCode)
        }
      }
    }, [_c('i', {
      staticClass: "sc-ico-nav sc-ico-01"
    }), _vm._v(" "), _c('a', {
      staticClass: "fb",
      staticStyle: {
        "color": "#fdfbfb"
      }
    }, [_vm._v(_vm._s(cat.catNameCn))]), _vm._v(" "), _c('i', {
      staticClass: "sc-ico-arrow"
    })]), _vm._v(" "), _c('div', {
      staticClass: "sc-submenu-all none",
      attrs: {
        "id": cat.catCode + '_child'
      },
      on: {
        "mouseenter": function($event) {
          _vm.childCateShow(cat.catCode)
        }
      }
    }, [_c('dl', [_c('dt', [_c('i'), _vm._v(_vm._s(cat.catNameCn))]), _vm._v(" "), _c('dd', [_vm._l((cat.catBoList), function(childCat) {
      return _c('a', {
        on: {
          "click": function($event) {
            _vm.getCatGoods(childCat.catCode, childCat.catNameCn)
          }
        }
      }, [_vm._v(_vm._s(childCat.catNameCn))])
    }), _vm._v(" "), _c('a', {
      on: {
        "click": function($event) {
          _vm.getMoreCatGoods(cat.catCode, cat.catNameCn)
        }
      }
    }, [_vm._v("更多")])], 2)])])])
  }))])]), _vm._v(" "), _c('ul', {
    staticClass: "nav fl"
  }, [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goIndex()
      }
    }
  }, [_vm._v("商城首页")])]), _vm._v(" "), _vm._l((_vm.catList), function(carBo, index) {
    return (index < 6) ? _c('li', [_c('a', {
      on: {
        "click": function($event) {
          _vm.getMoreCatGoods(carBo.catCode, carBo.catNameCn)
        }
      }
    }, [_vm._v(_vm._s(carBo.catNameCn))])]) : _vm._e()
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "clear mt15"
  }), _vm._v(" "), _c('div', {
    staticClass: "w1200 bc"
  }, [_c('div', {
    staticClass: "hq-crumb-wrap"
  }, [_c('ul', [_c('li', {
    staticClass: "item"
  }, [_vm._v("首页")]), _vm._v(" "), _c('li', {
    staticClass: "item sep"
  }, [_vm._v(">")]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_vm._v(_vm._s(_vm.sortParam))])])]), _vm._v(" "), _c('div', {
    staticClass: "sp-side-wrap"
  }, [_vm._m(0), _vm._v(" "), _c('ul', _vm._l((_vm.relativeShopList), function(relativeShop) {
    return _c('li', [_c('a', {
      staticClass: "fl pic",
      on: {
        "click": function($event) {
          _vm.goShop(relativeShop.shopCode)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": relativeShop.shopStandarLogo,
        "width": "106",
        "height": "106"
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "title"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.goShop(relativeShop.shopCode)
        }
      }
    }, [_vm._v(_vm._s(relativeShop.shopName))])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "sp-search-list"
  }, [_c('div', {
    staticClass: "l-hd"
  }, [_c('div', {
    staticClass: "top-num fr"
  }, [_vm._v("共" + _vm._s(_vm.totalItem) + "条 "), _c('span', {
    staticClass: "co2"
  }, [_vm._v(_vm._s(_vm.sortParam))])]), _vm._v(" "), _c('h3', [_vm._v("搜索结果")])]), _vm._v(" "), _c('div', {
    staticClass: "pro-list"
  }, [_c('ul', _vm._l((_vm.shopList), function(shopBo) {
    return _c('li', [_c('p', {
      staticClass: "img"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.goShop(shopBo.shopCode)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": shopBo.shopStandarLogo,
        "width": "265",
        "height": "265"
      }
    })])]), _vm._v(" "), _c('p', {
      staticClass: "title"
    }, [_c('i', {
      staticClass: "ico-shop-l"
    }), _c('a', {
      on: {
        "click": function($event) {
          _vm.goShop(shopBo.shopCode)
        }
      }
    }, [_vm._v(_vm._s(shopBo.shopName))])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "dp-pages tc"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.prePage()
      }
    }
  }, [_vm._v(" < ")]), _vm._v(" "), _vm._l((_vm.pageList), function(page) {
    return _c('a', {
      class: {
        "current_page": _vm.currentPage === page
      },
      on: {
        "click": function($event) {
          _vm.queryByPage(page)
        }
      }
    }, [_vm._v(_vm._s(page))])
  }), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.nextPage()
      }
    }
  }, [_vm._v(" > ")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('footermenu'), _vm._v(" "), _c('footercopyright')], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hd"
  }, [_c('h3', [_vm._v("相关店铺")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb20 ad-4 mt20"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/images/footer-ad-1.png"),
      "width": "1200",
      "height": "60"
    }
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57a061c2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/shop/shopsList.vue
// module id = pmnU
// module chunks = 1